import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api/client";
import type { AuthResponse } from "@/api/types";
import { transitionSession } from "@/lib/session-transition";

interface SignInInput {
  email: string;
  password: string;
}

export function useSignIn() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: SignInInput) => api.post("sessions", { json: data }).json<AuthResponse>(),
    onSuccess: (data, _variables, _result, context) => {
      transitionSession(queryClient, data.user, context);
    },
  });
}
